export const CHART_COLORS = [
  '#10B981', '#3B82F6', '#F59E0B', '#EF4444', '#8B5CF6', '#06B6D4',
  '#84CC16', '#F97316', '#EC4899', '#14B8A6', '#6366F1', '#A855F7',
  '#0EA5E9', '#22C55E', '#EAB308', '#DC2626', '#7C3AED', '#0891B2',
  '#65A30D', '#C026D3'
];

export const INVESTMENT_TYPE_LABELS = {
  bank_balance: 'Bank Balance',
  fixed_deposit: 'Fixed Deposit',
  mutual_fund: 'Mutual Fund',
  treasury_bill: 'Treasury Bill',
  quoted_stocks: 'Quoted Stocks',
  government_bond: 'Government Bond',
  corporate_bond: 'Corporate Bond',
  private_equity: 'Private Equity',
  convertible: 'Convertible',
  safe: 'SAFE Investment',
  crypto: 'Cryptocurrency',
  real_estate: 'Real Estate',
  etf: 'ETF',
  gold: 'Gold'
};

export const TYPE_CARD_COLORS = [
  'bg-blue-500', 'bg-orange-500', 'bg-emerald-500', 'bg-indigo-500',
  'bg-purple-500', 'bg-teal-500', 'bg-cyan-500', 'bg-rose-500',
  'bg-amber-500', 'bg-lime-500', 'bg-slate-500', 'bg-sky-600',
  'bg-violet-600', 'bg-yellow-600'
];

export const getTypeColor = (index) => TYPE_CARD_COLORS[index % TYPE_CARD_COLORS.length];

export const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};
